var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfoBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5013 2.41602C7.8313 2.41602 2.41797 7.82935 2.41797 14.4993C2.41797 21.1693 7.8313 26.5827 14.5013 26.5827C21.1713 26.5827 26.5846 21.1693 26.5846 14.4993C26.5846 7.82935 21.1713 2.41602 14.5013 2.41602Z",
    fill: "#5E93AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5026 8.45703C15.1672 8.45703 15.7109 9.00078 15.7109 9.66536V14.4987C15.7109 15.1633 15.1672 15.707 14.5026 15.707C13.838 15.707 13.2943 15.1633 13.2943 14.4987V9.66536C13.2943 9.00078 13.838 8.45703 14.5026 8.45703Z",
    fill: "#EFFBFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2943 19.3327C13.2943 18.6653 13.8353 18.1243 14.5026 18.1243C15.1699 18.1243 15.7109 18.6653 15.7109 19.3327C15.7109 20 15.1699 20.541 14.5026 20.541C13.8353 20.541 13.2943 20 13.2943 19.3327Z",
    fill: "#EFFBFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoBlue);
export default __webpack_public_path__ + "static/media/Icon_Info_Blue.3500de70f5eb3dee9f1ddabbe2c346ef.svg";
export { ForwardRef as ReactComponent };